var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"artai-iframe-section"},[_c('div',{staticClass:"artai-background-container"},[(!_vm.hideHeader)?_c('Header',{attrs:{"notificationIconClass":`fa-calendar-check`}}):_vm._e(),_c('ArtAI')],1),_c('div',{staticClass:"artai-iframe-footer-wrapper"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }